<template>
	<div id="helpDialog" class="modal" tabindex="-1" role="dialog">

		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<div class="modal-content wizard-content">
				<div class="modal-header wizard-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body wizard-body">
					<div class="">
						<p class="c14" v-if="!isAnonymized" selectable>
							<span class="c0 c17 selectable">Patient ID: </span> <span class="c2 selectable">{{ patientId
								}}</span>
							<span class="c0 c17 selectable">, Patient Name: </span> <span class="c2 selectable">{{
							patientFirstName
						}} {{
								patientLastName }}</span>
						</p>

						<p class="c14 c9 selectable" v-if="!isAnonymized">
							<span class="c17 c0"></span>
						</p>

						<p class="versions-header">
							<span class="c0 c17 selectable version-span">Version: </span> <span
								class="c2 selectable version-span">{{
							appVersion
						}}</span>
							<span class="expand-span" v-on:click="expandVersionsClick()">{{ expandSign }}</span>
							<!-- <div class="expand-span" v-on:click="expandVersionsClick()">{{ expandSign }}</div> -->
						</p>


						<div v-show="showVersions" class="versions-div">
							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Teeth Segmentation: </span> <span class="c2 selectable">{{
							versions.teethVersion
						}}</span>
							</p>
							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Bones Segmentation: </span> <span class="c2 selectable">{{
							versions.bonesVersion
						}}</span>
							</p>
							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Nerve Segmentation: </span> <span class="c2 selectable">{{
							versions.nerveVersion
						}}</span>
							</p>
							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Airway Segmentation: </span> <span class="c2 selectable">{{
							versions.airwayVersion
						}}</span>
							</p>
							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">2D Images: </span> <span class="c2 selectable">{{
							versions.fasymVersion
						}}</span>
							</p>

							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Intraoral Segmentation: </span> <span
									class="c2 selectable">{{
							versions.IOSSegmentationVersion
						}}</span>
							</p>

							<p class="c14 selectable" v-if="versions">
								<span class="c2 selectable">Crown Composition: </span> <span class="c2 selectable">{{
							versions.CrownCompositionVersion
						}}</span>
							</p>
						</div>
						<p class="c14 c9 selectable">
							<span class="c17 c0"></span>
						</p>
						<p class="c14">
							<span class="c0 c17">For more information, click on one of the images</span>
						</p>
						<p class="c14 c9">
							<span class="c17 c0"></span>
						</p>
						<div class="vertical-scroll">
							<!-- 1 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Airway Viewer </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Offers a clear view of the patient’s airway space, making it
										easier to evaluate its size and shape.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>
									<img class="help-image" src="images/help/help_image1.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/12992544-airway-view')">
									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/12992544-airway-view">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 2 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">DICOM Viewer </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> View and navigate the original CBCT scan in axial, sagittal, and
										coronal planes while exploring the AI-generated 3D segmentation.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image2.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/13032253-cbct-segmentation')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/13032253-cbct-segmentation">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 3 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Cross Section Report </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> The Cross Section provides a centralized view of key anatomical
										perspectives.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image3.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/15587403-cross-section-tmj-report')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/15587403-cross-section-tmj-report">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 4 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Cross Bite Report </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> A crossbite report identifies crossbites to support orthodontic
										diagnosis and treatment.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image4.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/15643888-cross-bite-report')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/15643888-cross-bite-report">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 5 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">3D Segmented CBCT with an IOS </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Combine intraoral scans (IOS) with CBCT (DICOM) for precise and
										efficient treatment planning. Learn how to upload, view, and export stitched
										files seamlessly.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image5.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/10391826-automatic-stitching-of-a-3d-segmented-cbct-with-an-ios')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/10391826-automatic-stitching-of-a-3d-segmented-cbct-with-an-ios">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 6 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Anchorage Report </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Determine the surface area of the tooth within the bone, opposing
										directional forces, and the predicted movement of intended anchors.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image6.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/13001683-anchorage-calculation-report')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/13001683-anchorage-calculation-report">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 7 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Stage Planning and Tooth Movement </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Visualize and plan tooth movement throughout every stage of
										treatment with powerful 3D simulation tools.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image7.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/13034012-ortho-menu-in-3d-view')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/13034012-ortho-menu-in-3d-view">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 8 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Front Face Image Overlay </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Overlay a patient's frontal facial photograph with AI-generated
										facial landmarks to evaluate facial symmetry, proportions, and soft tissue
										relationships.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image8.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/16097360-front-face-image-overlay')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/16097360-front-face-image-overlay">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 9 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">Smart Roots </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> By combining initial CBCT data with post-treatment IOS scans, our
										AI generates a comprehensive view of how treatment has affected both visible
										crowns and underlying roots.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image9.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/13038591-the-smart-roots-ios-cbct-integration')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/13038591-the-smart-roots-ios-cbct-integration">
												here</a></span>
									</p>
								</li>
							</ul>
							<p class="c6">
								<span class="c1"></span>
							</p>

							<!-- 10 -->
							<ul class="c10 start">
								<li class="c3 li-bullet-0">
									<span class="c0">3D Pano Roots </span>
									<span class="c0">&nbsp;</span>
									<span class="c2">-</span>
									<span class="c0">&nbsp;</span>
									<span class="c2"> Automatically generate a high-quality 3D panoramic view with
										detailed root visualization for a comprehensive assessment of tooth anatomy and
										alignment.</span>
									<p class="c6">
										<span class="c1"></span>
									</p>

									<img class="help-image" src="images/help/help_image10.gif"
										v-on:click="openExternalUrl('https://help.cephx.com/en/articles/16095547-3d-pano-roots')">

									<p class="c6">
										<span class="c1"></span>
									</p>
									<p class="c2">
										<span class="c2">Read more <a target="_blank" rel="noopener noreferrer"
												href="https://help.cephx.com/en/articles/16095547-3d-pano-roots">
												here</a></span>
									</p>
								</li>
							</ul>
						</div>

						<p class="c14 c9 ">
							<span class="c17 c0"></span>
						</p>
						<p class="c14">
							<span class="c17 c2">For more information, click on our <a target="_blank"
									rel="noopener noreferrer"
									href="https://cephx.com/wp-content/uploads/2026/08/3D-Manual-PDF.pdf">
									User Manual</a> to explore all the available features.</span>
						</p>

						<p class="c14 c9 ">
							<span class="c17 c0"></span>
						</p>
						<p class="c14">
							<span class="c17 c2">Visit our <a target="_blank" rel="noopener noreferrer"
									href="https://www.youtube.com/@cephxbyOrca/videos">
									YouTube channel</a> for more visual guides and tutorials.</span>
						</p>

						<p class="c14 c9">
							<span class="c17 c0"></span>
						</p>
						<p class="c14">
							<span class="c17 c2">If you need any assistance or would simply like to speak with us, feel free to contact us at <a target="_blank" rel="noopener noreferrer"
									href="mailto:support@cephx.com">
									support@cephx.com</a>.</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import $ from "jquery";
import swal from "sweetalert";

export default {
	name: "HelpDialog",
	props: ["mode", "patientFirstName", "patientLastName", "patientId", "isAnonymized", "versions", "appVersion"],
	data() {
		return {
			showVersions: false,
		}
	},
	methods: {
		showVideo: function (video) {
			var span = document.createElement("div");
			var sizeStr = screen.width > 600 ? 'width="560" height="315"' : "";
			span.innerHTML = `<iframe src="${video}" ${sizeStr} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
			swal({
				content: span,
				className: "swal-wide",
				button: false
			}).then(() => {
				const elements = document.getElementsByClassName("swal-overlay");
				while (elements.length > 0) {
					elements[0].parentNode.removeChild(elements[0]);
				}
			});
			//$(".swal-footer").attr("margin-top", "0");
			var $closeButton = $(
				"<button type='button' class='close swal-close' aria-label='Close'><span aria-hidden='true'>&times;</span></button>"
			);
			$(".swal-modal").append($closeButton);
			$(".swal-close").click(function () {
				swal.close();
			});
		},
		openExternalUrl: function (url) {
			window.open(url, '_blank');
		},
		expandVersionsClick: function () {
			this.showVersions = !this.showVersions;
		}
	},
	computed: {
		expandSign: function () {
			return this.showVersions ? "➖" : "➕";
		}
	}
};
</script>

<style scoped>
@import "../../css/wizard.css";

.modal-content {
	/* height: 95%; */
	max-height: 100vh;
}

.help-image {
	margin-left: -10px;
	width: 100%;
	height: auto;
	display: block;
	cursor: pointer;
}

/* .version-span {
	display: inline-block;
}

.versions-header {
	display: inline-block;
} */

.expand-span {
	cursor: pointer;
	margin-left: 10px;
	color: #1155cc;
	border: 1px solid #dbdbdb;
	padding: 4px 2px;

	/* display: inline-block;
	
	margin-top: -1px;
	width: 25px;
	height: 25px;
	text-align: center;
	font-weight: bold;
	padding: 0; */
}

.versions-div {
	margin-top: 4px;
}

.vertical-scroll {
	/* height: 400px; */
	max-height: calc(99vh - 335px);
	overflow-y: auto;
	margin: -10px -10px 0 -10px;
	padding: 10px;
	border: 1px dashed #dbdbdb;
}

#helpDialog {
	z-index: 99999;
}

.selectable {
	-moz-user-select: text;
	-webkit-user-select: text;
	-ms-user-select: text;
	user-select: text;
}

.modal-sm {
	max-width: 924px;
}

.modal-header {
	height: 20px;
}

.modal-header .close {
	padding-top: 0.3rem;
	padding-right: 0.5rem;
}

.modal-body {
	padding-top: 0;
	padding-left: 30px;
	padding-right: 30px;
}

ul {
	list-style-type: none;
}

ul>li:before {
	content: "\0025cf  ";
}

li.li-bullet-0:before {
	margin-left: -18pt;
	white-space: nowrap;
	display: inline-block;
	min-width: 18pt;
}

ol {
	margin: 0;
	padding: 0;
}

table td,
table th {
	padding: 0;
}

.c12 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 11pt;
	font-family: "Arial";
	font-style: normal;
}

.c4 {
	-webkit-text-decoration-skip: none;
	color: #000000;
	text-decoration: underline;
	vertical-align: baseline;
	text-decoration-skip-ink: none;
	font-family: "Arial";
	font-style: normal;
}

.c1 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 12pt;
	font-family: "Arial";
	font-style: normal;
}

.c3 {
	margin-left: 21.3pt;
	padding-top: 0pt;
	padding-left: 0pt;
	padding-bottom: 0pt;
	line-height: 1;
	text-align: justify;
}

.c13 {
	padding-top: 0pt;
	padding-bottom: 0pt;
	line-height: 1.15;
	orphans: 2;
	widows: 2;
	text-align: left;
}

.c6 {
	padding-top: 0pt;
	padding-bottom: 0pt;
	line-height: 1;
	text-indent: 36pt;
	text-align: left;
	height: 11pt;
}

.c17 {
	color: #000000;
	text-decoration: none;
	vertical-align: baseline;
	font-family: "Arial";
	font-style: normal;
}

.c5 {
	padding-top: 0pt;
	padding-bottom: 0pt;
	line-height: 1;
	text-align: justify;
}

.c14 {
	padding-top: 0pt;
	padding-bottom: 0pt;
	line-height: 1;
	text-align: left;
}

.c16 {
	background-color: #ffffff;
	max-width: 468pt;
	padding: 72pt 72pt 72pt 72pt;
}

.c7 {
	text-decoration-skip-ink: none;
	-webkit-text-decoration-skip: none;
	text-decoration: underline;
}

.c0 {
	font-size: 12pt;
	font-weight: 700;
}

.c8 {
	color: inherit;
	text-decoration: inherit;
}

.c10 {
	padding: 0;
	margin: 0;
}

.c15 {
	margin-left: 36pt;
}

.c2 {
	font-size: 12pt;
}

.c11 {
	color: #1155cc;
}

.c9 {
	height: 11pt;
}

.title {
	padding-top: 0pt;
	color: #000000;
	font-size: 26pt;
	padding-bottom: 3pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

.subtitle {
	padding-top: 0pt;
	color: #666666;
	font-size: 15pt;
	padding-bottom: 16pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

li {
	color: #000000;
	font-size: 11pt;
	font-family: "Arial";
}

p {
	margin: 0;
	color: #000000;
	font-size: 11pt;
	font-family: "Arial";
}

h1 {
	padding-top: 20pt;
	color: #000000;
	font-size: 20pt;
	padding-bottom: 6pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

h2 {
	padding-top: 18pt;
	color: #000000;
	font-size: 16pt;
	padding-bottom: 6pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

h3 {
	padding-top: 16pt;
	color: #434343;
	font-size: 14pt;
	padding-bottom: 4pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

h4 {
	padding-top: 14pt;
	color: #666666;
	font-size: 12pt;
	padding-bottom: 4pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

h5 {
	padding-top: 12pt;
	color: #666666;
	font-size: 11pt;
	padding-bottom: 4pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left;
}

h6 {
	padding-top: 12pt;
	color: #666666;
	font-size: 11pt;
	padding-bottom: 4pt;
	font-family: "Arial";
	line-height: 1.15;
	page-break-after: avoid;
	font-style: italic;
	orphans: 2;
	widows: 2;
	text-align: left;
}
</style>
